import React, { Component } from 'react';
import { withRouter } from "react-router";
import LeftBar from '../Site/LeftBar';
import ProductKitList from './ProductKitList';

import './style.css';

class ProductKits extends Component {

  render() {
    return (
      <div>
        <LeftBar />
        <ProductKitList />
      </div>    


    );
  }
}

export default withRouter(ProductKits);